import { render, staticRenderFns } from "./MultiPaneLayout.vue?vue&type=template&id=51689017&scoped=true&"
import script from "./MultiPaneLayout.vue?vue&type=script&lang=js&"
export * from "./MultiPaneLayout.vue?vue&type=script&lang=js&"
import style0 from "./MultiPaneLayout.vue?vue&type=style&index=0&id=51689017&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51689017",
  null
  
)

export default component.exports